// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"a3c2bee7","508":"a12defe0","630":"254bb24c","776":"0c8c32b7"}[chunkId] + ".chunk.js";
};